/* eslint-disable no-unused-vars */
import axios from "axios";
import { AgentUtils } from "./AgentUtils";
let baseUrl = "";
if (AgentUtils.isAndroid()) {
  baseUrl = window.JSBridge.getBaseUrl();
} else {
  baseUrl = window.location.origin;
}

export default axios.create({
  baseURL: baseUrl,
  responseType: "json",
});
